import { meninySK } from "./sk";
import { meninyCS } from "./cs";

export function getMeniny(country) {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const datasets = {
    sk: meninySK,
    cs: meninyCS,
    cz: meninyCS,
  };

  const meninyData = datasets[country];
  if (!meninyData) {
    throw new Error("Unsupported country");
  }

  const todayMonth = today.getMonth() + 1;
  const todayDate = today.getDate();
  const tomorrowMonth = tomorrow.getMonth() + 1;
  const tomorrowDate = tomorrow.getDate();

  const todayMeniny = meninyData[todayMonth]?.[todayDate] ?? null;
  const tomorrowMeniny = meninyData[tomorrowMonth]?.[tomorrowDate] ?? null;

  return {
    today: todayMeniny,
    tomorrow: tomorrowMeniny,
  };
}
